import SalaryFormFields from './SalaryFormFields.component';

export default SalaryFormFields;